const AV_CONTENT_ID = "avContent";

export class AvContent {
  static pageRule() {
    return document.getElementById(AV_CONTENT_ID)?.dataset.rule;
  }
}
